import { wrapNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';

const AlertScreenContent = lazy(() => import('./AlertScreen.content'));

export const AlertScreen = wrapNavigatorScreen(AlertScreenContent, {
  headerShown: false,
  animationEnabled: false,
  cardStyle: { backgroundColor: 'transparent' },
  presentation: 'transparentModal',
});
